import { render, staticRenderFns } from "./ExamEditForm.vue?vue&type=template&id=ed10d30c"
import script from "./ExamEditForm.vue?vue&type=script&lang=js"
export * from "./ExamEditForm.vue?vue&type=script&lang=js"
import style0 from "./ExamEditForm.vue?vue&type=style&index=0&id=ed10d30c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports